'use strict';

import { get, filter, includes, each } from 'lodash';
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import io from 'socket.io-client';

import IconButton from 'material-ui/IconButton';
import ProfileIcon from '../../../common/svgs/ProfileIcon';
import NotificationBellOff from '../../../common/svgs/NotificationBellOff';
import NotificationBellOn from '../../../common/svgs/NotificationBellOn';

import Notification from '../../../common/components/Notification';

// redux interactions
import * as asyncActionCreator from '../../../redux/actionCreators/async';
import { updateAlerts } from '../../../redux/actionCreators/sync';
import { logOut } from '../../../redux/actionCreators/async/auth';

const socket = io(process.env.BASE_URL);

@connect(store => ({
  user: store.user,
  alerts: store.alerts,
  labels: get(store.labels, 'Common', {}),
}), {
  logOut
})
export default class UserMenu extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    alerts: PropTypes.object,
    dispatch: PropTypes.func,
    logOut: PropTypes.func,
    labels: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.dismissAlert = this.dismissAlert.bind(this);
    this.navigateAlert = this.navigateAlert.bind(this);

    this.state = {
      newAlerts: []
    };

    this.dismissTimeout = [];
    this.logOut = ::this.logOut;
  }

  componentDidMount() {
    // register sockets
    socket.emit('register employee socket', this.props.user.id);
    socket.on('alert', (data) => this.incomingAlert(data));

    this.loadAlerts();
  }

  componentWillUnmount() {
    if (this.dismissTimeout) {
      each(this.dismissTimeout, timeout => timeout && clearTimeout(timeout));
    }

    socket.emit('deregister employee socket', this.props.user.id);
  }

  loadAlerts() {
    // check current alerts
    this.props.dispatch(asyncActionCreator.getAlerts({
      success: (data) => {
        this.props.dispatch(updateAlerts({...data.items}));
      }
    }));
  }

  incomingAlert(alertData) {
    this.setState({newAlerts: this.state.newAlerts.concat(alertData)});
    this.loadAlerts();

    this.dismissTimeout[alertData.id](setTimeout(() => {
      this.dismissAlert(alertData.id);
    }, 5000));
  }

  dismissAlert(alertId) {
    this.setState({newAlerts: filter(this.state.newAlerts, (a) => a.id != alertId)});

    this.props.dispatch(asyncActionCreator.readAlert(alertId, {
      success: (data) => this.loadAlerts()
    }));

    if (this.dismissTimeout[alertId]) {
      clearTimeout(this.dismissTimeout[alertId]);
      this.dismissTimeout[alertId] = null;
    }
  }

  navigateAlert(alert, target, route) {
    let path = '/admin';
    if (target === 'user') {
      path = path + `/${alert.alertData.location || alert.alertData.locationName}/${alert.alertData.target}/details`;
    }
    else if (target === 'location') {
      path = path + `/${alert.alertData.location || alert.alertData.locationName}`;
    } else if (target === null) {
      path = route;
    }

    this.props.dispatch(push(path));
  }

  logOut() {
    const website = this.props.labels.website;
    this.props.logOut()
      .then(() => {
        window.location = website;
      });
  }

  render() {
    let logoutTooltip = `Logout: ${this.props.user.firstName} ${this.props.user.lastName}`;
    return (
      <div>
        <ul className='user-menu' data-id='User Menu'>
        {!!~this.props.user.roles.findIndex(role => !includes(['Applicant', 'Client'], role))
          &&
          <div>
            {!!Object.keys(filter(this.props.alerts, (a) => !a.isRead)).length > 0
              &&
              <li><IconButton style={{width: 'auto', height: 'auto', padding: '0', border: '0'}} data-id='notification-icon-button' tooltip='Notifications' tooltipPosition='bottom-center'>
                <NotificationBellOn data-id='alerts-pending' onClick={() => this.props.dispatch(push('/admin/alerts'))}/>
              </IconButton></li>
              ||
              <li><IconButton style={{width: 'auto', height: 'auto', padding: '0', border: '0'}} data-id='notification-icon-button' tooltip='Notifications' tooltipPosition='bottom-center'>
                <NotificationBellOff data-id='alerts-pending' onClick={() => this.props.dispatch(push('/admin/alerts'))}/>
              </IconButton></li>
            }
            <li><IconButton style={{width: 'auto', height: 'auto', padding: '0', border: '0'}} data-id='logout-icon-button' tooltip={logoutTooltip} tooltipPosition='bottom-center'>
              <ProfileIcon data-id='logout-icon' onClick={() => this.logOut()}/>
            </IconButton></li>
          </div>
          ||
          <h3 className='hover-link' data-id='logout-text' onClick={() => this.logOut()}>LOGOUT</h3>
        }


        </ul>

        <Notification
          alerts={this.state.newAlerts}
          dismiss={this.dismissAlert}
          navigate={this.navigateAlert}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/UserMenu/index.js